/**
 * Removes all unnecessary parts of the domain (e.g. protocol, auth, port, path, query)
 * and parses the remaining domain. The returned object contains the properties 'subdomain', 'domain' and 'tld'.
 *
 * Since the top-level domain is handled differently by every country, this function only
 * supports all tlds listed in lib/build/tld.txt.
 *
 * If the given url is not valid or isn't supported by the tld.txt, this function returns null.
 *
 * @param {string} url
 * @returns {Object|null}
 */
type parseDomainOutput = {
  tld: string
  domain: string
}

export function parseDomain(url: string): parseDomainOutput | null {
  let domain
  const normalizedUrl = url.trim().toLowerCase()
  try {
    domain = new URL(
      normalizedUrl.includes('https')
        ? normalizedUrl
        : `https://${normalizedUrl}`
    ).hostname
    // domain will now be something like sub.domain.example.com
  } catch (e) {
    return null
  }
  const dotIndex = domain.indexOf('.')
  return {
    tld: domain.slice(dotIndex + 1),
    domain: domain.slice(0, dotIndex),
  }
}
